export const removeOverhangLine = {
  beforeDraw: chart => {
    const ctx = chart.chart.ctx;

    const x_axis = chart.scales["x-axis-0"];
    const y_axis = chart.scales["y-axis-0"];

    x_axis.options.gridLines.display = false;
    y_axis.options.gridLines.display = false;

    x_axis.ticks.forEach((label, index) => {
      const x = x_axis.getPixelForValue(label, index);
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, y_axis.top);
      ctx.lineTo(x, y_axis.bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = x_axis.options.gridLines.color;
      if (index === 0 && y_axis.options.gridLines.zeroLineColor) {
        ctx.strokeStyle = y_axis.options.gridLines.zeroLineColor;
      }
      ctx.stroke();
      ctx.restore();
    });

    y_axis.ticks.forEach((label, index) => {
      const y = y_axis.getPixelForValue(label, index);
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x_axis.left, y);
      ctx.lineTo(x_axis.right, y);
      ctx.lineWidth = 1;
      ctx.strokeStyle = y_axis.options.gridLines.color;
      if (
        index === y_axis.ticks.length - 1 &&
        y_axis.options.gridLines.zeroLineColor
      ) {
        ctx.strokeStyle = y_axis.options.gridLines.zeroLineColor;
      }
      ctx.stroke();
      ctx.restore();
    });
  }
};
